module.exports = __webpack_public_path__ + "static/media/intro-parents-png-sep-2026.668f19ed.png";